import utilities from '@/services/utilities/utilities';

export default {
  run: function (text) {
    let textSegments = text.split(',');
    let specificHandStringsFromTextSegment;
    let specificHandStrings = [];

    if (text === '') {
      return [];
    }

    textSegments.forEach(function (textSegment) {
      specificHandStringsFromTextSegment = this._getSpecificHandStringsFromTextSegment(textSegment);
      specificHandStrings.pushEachElement(specificHandStringsFromTextSegment)
    }, this);

    return specificHandStrings;
  },
  _getSpecificHandStringsFromTextSegment: function (textSegment) {
    // hardcoded stuff
    if (textSegment === 'aqs+') {
      return [
        'ackc', 'asks', 'ahkh', 'adkd',
        'acqc', 'asqs', 'ahqh', 'adqd'
      ];
    } else if (textSegment === 'aqo+') {
      return [
        'acks', 'ackh', 'ackd', 'askc', 'askh', 'askd', 'ahkc', 'ahks', 'ahkd', 'adkc', 'adks', 'adkh',
        'acqs', 'acqh', 'acqd', 'asqc', 'asqh', 'asqd', 'ahqc', 'ahqs', 'ahqd', 'adqc', 'adqs', 'adqh'
      ];
    } else if (textSegment === 'aq+') {
      return [
        'ackc', 'acks', 'ackh', 'ackd', 'askc', 'asks', 'askh', 'askd', 'ahkc', 'ahks', 'ahkh', 'ahkd', 'adkc', 'adks', 'adkh', 'adkd',
        'acqc', 'acqs', 'acqh', 'acqd', 'asqc', 'asqs', 'asqh', 'asqd', 'ahqc', 'ahqs', 'ahqh', 'ahqd', 'adqc', 'adqs', 'adqh', 'adqd'     
      ];
    }

    let textSegmentType = this.__getTextSegmentType(textSegment);

    if (textSegmentType === 'ascending') { // 66+
      return this.__getSpecificHandStringsFromAscendingTextSegment(textSegment);
    } else if (textSegmentType === 'descending') { // 66-
      return this.__getSpecificHandStringsFromDescendingTextSegment(textSegment);
    } else if (textSegmentType === 'range') { // 66-33
      return this.__getSpecificHandStringsFromRangeTextSegment(textSegment);
    } else if (textSegmentType === 'general hand') { // 66
      return this.__getSpecificHandStringsFromGeneralHandTextSegment(textSegment);
    } else if (textSegmentType === 'specific hand') { // eg. 6c6s
      return [ utilities.hands.getNormalizedSpecificHandString(textSegment) ];
    } else {
      throw new Error('Unable to find text segment typpe.');
    }
  },
  __getTextSegmentType: function (textSegment) {
    if (textSegment[2] === '+' || textSegment[3] === '+') {
      return 'ascending';
    } else if (textSegment.length >= 5 && textSegment.length <= 7) {
      return 'range';
    } else if (textSegment.includes('-')) {
      return 'descending';
    } else if (textSegment.length === 2 || textSegment.length === 3) {
      return 'general hand';
    } else if (textSegment.length === 4) {
      return 'specific hand';
    } else {
      throw new Error('Problem getting text segment type.');
    }
  },
  __getSpecificHandStringsFromAscendingTextSegment: function (textSegment) {
    let gapperType = this.___getGapperType(textSegment);
    let pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromAscendingPocketPairTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromAscendingConnectorTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromAscendingOneGapperTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedAscendingTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getGapperType: function (textSegment) {
    let rankOne = textSegment[0];
    let rankTwo = textSegment[1];
    let rankThree;
    let rankFour;
    let spaceBetweenRanksOne = utilities.ranks.getSpaceBetweenRanks([rankOne, rankTwo]);
    let spaceBetweenRanksTwo;

    // range
    if (textSegment.length === 5 || textSegment.length === 7) {
      if (textSegment.length === 5) {
        rankThree = textSegment[3];
        rankFour = textSegment[4];
      } else if (textSegment.length === 7) {
        rankThree = textSegment[4];
        rankFour = textSegment[5];
      }

      spaceBetweenRanksTwo = utilities.ranks.getSpaceBetweenRanks([rankThree, rankFour]);

      if (spaceBetweenRanksOne === 1 && spaceBetweenRanksTwo === 1) {
        return 'connector';
      } else if (spaceBetweenRanksOne === 2 && spaceBetweenRanksTwo === 2) {
        return 'one gapper';
      } else {
        return 'spaced';
      }
    }

    // ascending or descending
    else {
      if (spaceBetweenRanksOne === 1) {
        return 'connector';
      } else if (spaceBetweenRanksOne === 2) {
        return 'one gapper';
      } else {
        return 'spaced';
      }
    }

  },
  ___getSpecificHandStringsFromAscendingPocketPairTextSegment: function (textSegment) {
    let rank = textSegment[0];
    let generalHandStrings = [];

    utilities.ranks.forEachRank('a', rank, function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromAscendingConnectorTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let oneLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank('a', highRankFromTextSegment, function (currRank) {
      oneLower = utilities.ranks.getRankOneLower(currRank);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + oneLower + 's');
        generalHandStrings.push(currRank + oneLower + 'o');
      } else {
        generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromAscendingOneGapperTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let twoLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank('a', highRankFromTextSegment, function (currRank) {
      twoLower = utilities.ranks.getRankNUnitsLower(currRank, 2);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + twoLower + 's');
        generalHandStrings.push(currRank + twoLower + 'o');
      } else {
        generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedAscendingTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let lowRankFromTextSegment = textSegment[1];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let oneLowerThanHighRankFromTextSegment = utilities.ranks.getRankOneLower(highRankFromTextSegment);
    let generalHandStrings = [];

    utilities.ranks.forEachRank(oneLowerThanHighRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      if (suitedAndOffsuit) {
        generalHandStrings.push(highRankFromTextSegment + currRank + 's');
        generalHandStrings.push(highRankFromTextSegment + currRank + 'o');
      } else {
        generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromDescendingTextSegment: function (textSegment) {
    let gapperType = this.___getGapperType(textSegment);
    let pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromDescendingPocketPairTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromDescendingConnectorTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromDescendingOneGapperTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedDescendingTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getSpecificHandStringsFromDescendingPocketPairTextSegment: function (textSegment) {
    let rank = textSegment[0];
    let generalHandStrings = [];

    utilities.ranks.forEachRank(rank, '2', function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromDescendingConnectorTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let oneLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highRankFromTextSegment, '3', function (currRank) {
      oneLower = utilities.ranks.getRankOneLower(currRank);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + oneLower + 's');
        generalHandStrings.push(currRank + oneLower + 'o');
      } else {
        generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromDescendingOneGapperTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let twoLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highRankFromTextSegment, '4', function (currRank) {
      twoLower = utilities.ranks.getRankNUnitsLower(currRank, 2);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + twoLower + 's');
        generalHandStrings.push(currRank + twoLower + 'o');
      } else {
        generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedDescendingTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let lowRankFromTextSegment = textSegment[1];
    let suitedAndOffsuit = textSegment.length === 3;
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let generalHandStrings = [];

    utilities.ranks.forEachRank(lowRankFromTextSegment, '2', function (currRank) {
      if (suitedAndOffsuit) {
        generalHandStrings.push(highRankFromTextSegment + currRank + 's');
        generalHandStrings.push(highRankFromTextSegment + currRank + 'o');
      } else {
        generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
      }
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromRangeTextSegment: function (textSegment) {
    let gapperType = this.___getGapperType(textSegment);
    let pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromPocketPairRangeTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromConnectorRangeTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromOneGapperRangeTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedRangeTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getSpecificHandStringsFromPocketPairRangeTextSegment: function (textSegment) {
    let highRank = textSegment[0];
    let lowRank = textSegment[3];
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highRank, lowRank, function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromConnectorRangeTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let lowRankFromTextSegment = textSegment[4];
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let oneLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      oneLower = utilities.ranks.getRankOneLower(currRank);
      generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromOneGapperRangeTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let lowRankFromTextSegment = textSegment[4];
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let twoLower;
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      twoLower = utilities.ranks.getRankNUnitsLower(currRank, 2);
      generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedRangeTextSegment: function (textSegment) {
    let highRankFromTextSegment = textSegment[0];
    let highLowRankFromTextSegment = textSegment[1];
    let lowLowRankFromTextSegment = textSegment[5];
    let suitedOrOffsuitFromTextSegment = textSegment[2];
    let generalHandStrings = [];

    utilities.ranks.forEachRank(highLowRankFromTextSegment, lowLowRankFromTextSegment, function (currRank) {
      generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
    });

    return utilities.hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromGeneralHandTextSegment: function (textSegment) {
    let pocketPair = (textSegment.length === 2) && (textSegment[0] === textSegment[1]);

    if (pocketPair || textSegment.length === 3) {
      return utilities.hands.getAllSpecificHandStringsFromGeneralHandString(textSegment);
    }

    else if (textSegment.length === 2) {
      return utilities.hands.getAllSpecificHandStringsFromGeneralHandString(textSegment + 's');
      return utilities.hands.getAllSpecificHandStringsFromGeneralHandString(textSegment + 'o');
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/text/get-specific-hand-strings-from-text.js